import arrow from '../styles/img/arrow/arrow.svg';
import pikkophone from '../styles/img/pikkophone.svg';
import { useNavigate } from 'react-router-dom';
import { NUMBER_SCREEN, SCAN_CHECK } from '../constants/routes';

export const CreateAccountCard = () => {
  const navigate = useNavigate();

  const goNext = (nextStep) => {
    localStorage.setItem('PREV_LOGIN_PAGE', SCAN_CHECK);
    navigate(`${nextStep}`, { state: { prevPage: SCAN_CHECK } });
  };

  return (
    <>
      <div
        className="principal_drawer"
        onClick={() => goNext(NUMBER_SCREEN)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            goNext(NUMBER_SCREEN);
          }
        }}
      >
        <div>
          <img src={pikkophone} alt="" />
        </div>
        <div className="partOfCardGift">
          <div className="text_deux green" style={{ fontSize: '12px' }}>
            Pikko Compte
          </div>
          <div className="text_deux" style={{ fontSize: '16px' }}>
            Gagne du temps pour la prochaine fois !
          </div>
          <div className="reward_creation_account_div">
            <div className="text_un" style={{ fontSize: '20px' }}>
              Crée-toi un compte
            </div>
            <img src={arrow} alt="arrow" />
          </div>
        </div>
      </div>

      <div
        onClick={() => goNext(NUMBER_SCREEN)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            goNext(NUMBER_SCREEN);
          }
        }}
        role="button"
        tabIndex={0}
      />
    </>
  );
};
